import { Modal } from "../ui/modal/Modal"
import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"
import { useQuery } from "../../hooks/useQuery"
import { useTranslation } from "react-i18next"
import { AsyncButton } from "../ui/AsyncButton"
import { useState } from "react"
import toast from "react-hot-toast"

const Pregunta = ({ q, ix, up, down, setQA }) => {
  const { t } = useTranslation()

  const [newAnswer, setNewAnswer] = useState("")

  const deletePregunta = () => {
    const ok = window.confirm(t(`modals.modal_edit_qa.are_you_sure`))
    if (!ok) return
    setQA((currrents) => {
      const cpy = { ...currrents }
      cpy.questions = cpy.questions.filter((_, i) => i !== ix)
      return cpy
    })
  }

  const changeTitle = (newTitle) =>
    setQA((currrents) => {
      const cpy = { ...currrents }
      cpy.questions[ix].title = newTitle
      return cpy
    })

  const toggleCheck = (ix, newval) =>
    setQA((currrents) => {
      const cpy = { ...currrents }
      cpy.questions[ix].checked = newval
      return cpy
    })

  const changeAnswer = (aix, newAnswer) =>
    setQA((currrents) => {
      const cpy = { ...currrents }
      cpy.questions[ix].accepted_answers[aix] = newAnswer
      return cpy
    })

  const deleteAnswer = (aix) =>
    setQA((currrents) => {
      const cpy = JSON.parse(JSON.stringify(currrents))
      cpy.questions[ix].accepted_answers = cpy.questions[
        ix
      ].accepted_answers.filter((_, i) => i !== aix)
      return cpy
    })

  const addNewAnswer = () =>
    setQA((currrents) => {
      if (!newAnswer.length) return currrents
      const cpy = JSON.parse(JSON.stringify(currrents))
      cpy.questions[ix].accepted_answers.push(newAnswer)
      setNewAnswer("")
      return cpy
    })

  return (
    <>
      <div className="form-group">
        <div className="d-flex align-items-start mb-4">
          <div className="d-flex pt-1 pe-2">
            <input
              type="checkbox"
              checked={q.checked}
              onChange={() => toggleCheck(ix, !q.checked)}
              className="mx-2"
            />
            <button onClick={() => up(ix)} className="btn px-0 py-0 border-0">
              ⬆️
            </button>
            <button onClick={() => down(ix)} className="btn px-0 py-0 border-0">
              ⬇️
            </button>
          </div>
          <div className="d-flex flex-column justify-content-start flex-grow-1 pt-1">
            <div className="input-group mb-1">
              <input
                type="text"
                value={q.title}
                onChange={(e) => changeTitle(e.target.value)}
                placeholder={t(`admin.qa.title`)}
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
              <span
                onClick={() => deletePregunta()}
                className="input-group-text user-select-none"
                role="button"
              >
                ❌
              </span>
            </div>
            <label className="form-label pe-5">
              {t(`admin.qa.correct_possible_answers`)}
            </label>
            <div className="d-flex flex-column" style={{ width: "60%" }}>
              {q.accepted_answers.map((a, aix) => (
                <div key={aix} className="input-group input-group-sm mb-1">
                  <input
                    type="text"
                    value={a}
                    onChange={(e) => changeAnswer(aix, e.target.value)}
                    placeholder={t(`admin.qa.answer_placeholder`)}
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                  <span
                    onClick={() => deleteAnswer(aix)}
                    className="input-group-text user-select-none"
                    role="button"
                  >
                    ❌
                  </span>
                </div>
              ))}
              {/* agregar respuesta */}
              <div className="input-group input-group-sm mb-1">
                <input
                  type="text"
                  value={newAnswer}
                  onChange={(e) => setNewAnswer(e.target.value)}
                  placeholder={t(`admin.qa.add_answer`)}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
                <span
                  className="input-group-text user-select-none"
                  onClick={addNewAnswer}
                  role="button"
                >
                  ➕
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </>
  )
}

const NuevaPregunta = ({ setQA }) => {
  const { t } = useTranslation()

  const [title, setTitle] = useState("")

  const addPregunta = () =>
    setQA((currrents) => {
      if (!title.length) return currrents
      const cpy = JSON.parse(JSON.stringify(currrents))
      cpy.questions.push({
        title,
        checked: true,
        accepted_answers: [],
      })
      setTitle("")
      return cpy
    })

  return (
    <>
      <div className="form-group">
        <div className="d-flex align-items-start mb-4">
          <div className="d-flex pt-1 pe-2">
            <input
              type="checkbox"
              disabled={true}
              checked={true}
              className="mx-2"
            />
            <button disabled={true} className="btn px-0 py-0 border-0">
              ⬆️
            </button>
            <button disabled={true} className="btn px-0 py-0 border-0">
              ⬇️
            </button>
          </div>
          <div className="d-flex flex-column justify-content-start flex-grow-1 pt-1">
            <div className="input-group mb-1">
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder={t(`admin.qa.new_question_placeholder`)}
                className="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
              />
              <span
                onClick={() => addPregunta()}
                className="input-group-text user-select-none"
                role="button"
              >
                ➕
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const Body = ({ QA, setQA }) => {
  const { t } = useTranslation()

  // manipulacion de la data
  // up mueve la pregunta con indice `ix` hacia arriba
  const up = (ix) =>
      setQA((current) => {
        const cpy = JSON.parse(JSON.stringify(current))
        if (ix === 0) return cpy
        const aux = cpy.questions[ix - 1]
        cpy.questions[ix - 1] = cpy.questions[ix]
        cpy.questions[ix] = aux
        return cpy
      }),
    down = (ix) =>
      setQA((current) => {
        const cpy = JSON.parse(JSON.stringify(current))
        if (ix === cpy.questions.length - 1) return cpy
        const aux = cpy.questions[ix + 1]
        cpy.questions[ix + 1] = cpy.questions[ix]
        cpy.questions[ix] = aux
        return cpy
      })

  return (
    <>
      <div className="p-3 pt-0" style={{ background: "hsl(0deg 0% 90%)" }}>
        <div className="form-group">
          <label className="form-label mt-4">{t(`admin.qa.title`)}</label>
          <input
            onChange={(e) =>
              setQA((current) => ({ ...current, title: e.target.value }))
            }
            value={QA.title ?? ""}
            className="form-control"
            placeholder={t(`admin.qa.title`)}
          />
        </div>

        <div className="form-group">
          <label className="form-label mt-4">{t(`admin.qa.text`)}</label>
          <textarea
            style={{ minHeight: "200px" }}
            disabled={true}
            defaultValue={QA.text}
            className="form-control"
          ></textarea>
        </div>

        <br />

        <label className="form-label">{t(`admin.qa.questions`)}</label>
        {QA.questions?.map((q, ix) => {
          return (
            <Pregunta
              key={ix}
              ix={ix}
              up={up}
              down={down}
              q={q}
              setQA={setQA}
            />
          )
        })}
        <NuevaPregunta setQA={setQA} />
      </div>
    </>
  )
}

const Footer = ({ show, query, runQuery }) => {
  const { t } = useTranslation()

  const handleCancelar = () => show[1](false)
  return (
    <>
      <button
        type="button"
        className="btn btn-danger"
        onClick={() => handleCancelar()}
      >
        {t(`ui.btns.cancel`)}
      </button>

      <AsyncButton
        onClick={() => runQuery()}
        disabled={query.isPending}
        name={t(`ui.btns.submit`)}
        sending={query.isPending}
      />
    </>
  )
}

export const ModalQA = ({ show, data, setEntries, cleanForm }) => {
  const [QA, setQA] = useState(data)

  const query = useQuery()

  const runQuery = async () => {
    const no_title = QA.title.length === 0
    if (no_title) {
      toast.error(t(`modals.modal_edit_qa.title_is_empty`))
      return
    }

    const no_questions = QA.questions.length === 0
    if (no_questions) {
      toast.error(t(`modals.modal_edit_qa.no_questions`))
      return
    }

    const empty_question_title = QA.questions.some((q) => q.title.length === 0)
    if (empty_question_title) {
      toast.error(t(`modals.modal_edit_qa.empty_question_title`))
      return
    }

    const no_answers_question = QA.questions.some(
      (q) =>
        q.accepted_answers.length === 0 ||
        q.accepted_answers.some((a) => !a.length)
    )
    if (no_answers_question) {
      toast.error(t(`modals.modal_edit_qa.no_answers_or_empty_question`))
      return
    }

    // recolecto toda la data necesaria para el fetch
    const tkn = getCookie("jwt"),
      tiene_id = QA.id ?? false,
      { url, opt } = tiene_id
        ? api.qa.update({ token: tkn, qa: QA, qa_id: QA.id })
        : api.qa.create({ token: tkn, qa: QA })

    // ejecuto
    query.url.current = url
    query.opt.current = opt

    query.run({
      onOk: () => {
        toast.success(t(`ui.msgs.successful_save`))
        if (setEntries)
          setEntries((current) => ({
            total: current.total,
            entries: current.entries.map((c) => {
              if (c.id !== data.id) return c
              return { ...QA, tags: QA.tags.map((t) => ({ id: -1, name: t })) }
            }),
          }))
        cleanForm()
        show[1](false)
      },
      onErr: (err) => {
        console.error(err)
        toast.error(t(`ui.msgs.something_went_wrong`))
      },
    })
  }

  const { t } = useTranslation()

  return (
    <>
      <Modal
        id="editar-qa"
        className="bigger"
        show={show}
        header={
          <center>
            {t(`admin.qa.${data.id ? "edit_qa_set" : "new_qa_set"}`)}
          </center>
        }
        body={<Body QA={QA} setQA={setQA} />}
        footer={<Footer show={show} query={query} runQuery={runQuery} />}
      />
    </>
  )
}
